var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "YdDialog",
    {
      attrs: {
        visible: _vm.visible,
        "append-to-body": "",
        width: "40%",
        title: _vm.title,
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticStyle: { "margin-left": "30px", "margin-right": "10px" },
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "mini",
            "label-position": "left",
            "label-width": "80px",
          },
        },
        [
          _vm.prizeType !== "none"
            ? _c(
                "el-form-item",
                { attrs: { label: "奖品", prop: "prizesId" } },
                [
                  _vm.form.type === 4
                    ? _c("div", [_vm._v(_vm._s(_vm.form.prizeName))])
                    : _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.changeSelect },
                          model: {
                            value: _vm.form.prizesId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "prizesId", $$v)
                            },
                            expression: "form.prizesId",
                          },
                        },
                        _vm._l(_vm.prizeList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                ],
                1
              )
            : _vm._e(),
          _vm.prizeType !== "none" && _vm.form.type !== 4
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "奖品库存",
                    prop: "numbers",
                    rules: _vm.form.id
                      ? [{ required: false }]
                      : _vm.rules.numbers,
                  },
                },
                [
                  !_vm.form.id
                    ? _c(
                        "div",
                        [
                          _c("el-input-number", {
                            attrs: { controls: false, min: 0 },
                            model: {
                              value: _vm.form.numbers,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "numbers", $$v)
                              },
                              expression: "form.numbers",
                            },
                          }),
                          _vm.prizeData.length &&
                          _vm.prizeData[0].prizeType !== 2
                            ? _c("span", { staticClass: "margin-left-10" }, [
                                _vm._v(
                                  "数量不可超过（" +
                                    _vm._s(
                                      _vm.prizeData.length
                                        ? _vm.prizeData[0].availableNumbers
                                        : 0
                                    ) +
                                    "）个"
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: _vm.prizeData,
                                border: "",
                                size: "mini",
                                "max-height": "280px",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "已配置库存",
                                  align: "center",
                                  prop: "numbers",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("div", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  scope.row.numbers === 0
                                                    ? 0
                                                    : scope.row.numbers
                                                    ? scope.row.numbers
                                                    : "-"
                                                ) +
                                                "\n              "
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2699861681
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "实时剩余库存",
                                  align: "center",
                                  prop: "remainNumbers",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("div", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  scope.row.remainNumbers === 0
                                                    ? 0
                                                    : scope.row.remainNumbers
                                                    ? scope.row.remainNumbers
                                                    : "-"
                                                ) +
                                                "\n              "
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3098908813
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "可分配库存",
                                  align: "center",
                                  prop: "availableNumbers",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("div", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  scope.row.availableNumbers ===
                                                    0
                                                    ? 0
                                                    : scope.row.availableNumbers
                                                    ? scope.row.availableNumbers
                                                    : "-"
                                                ) +
                                                "\n              "
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1553280104
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            {
                              staticClass:
                                "margin-top-15 flex flex flex-justify-center flex-align-center",
                            },
                            [
                              _c(
                                "el-col",
                                { staticStyle: { width: "100px" } },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.form.inventoryType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "inventoryType",
                                            $$v
                                          )
                                        },
                                        expression: "form.inventoryType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          staticClass: "margin-top-10",
                                          attrs: { label: 1 },
                                        },
                                        [_vm._v("加库存")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          staticClass: "margin-top-20",
                                          attrs: {
                                            label: 0,
                                            disabled: _vm.activeStatus === 2,
                                          },
                                        },
                                        [_vm._v("减库存")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("el-col", [
                                _c(
                                  "div",
                                  [
                                    _c("el-input-number", {
                                      staticStyle: {
                                        width: "100px",
                                        "margin-left": "10px",
                                      },
                                      attrs: { controls: false, min: 0 },
                                      model: {
                                        value: _vm.form.numbers,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "numbers", $$v)
                                        },
                                        expression: "form.numbers",
                                      },
                                    }),
                                    _vm.prizeData.length &&
                                    _vm.prizeData[0].prizeType !== 2 &&
                                    _vm.form.type !== 4
                                      ? _c(
                                          "span",
                                          { staticClass: "margin-left-10" },
                                          [
                                            _vm._v(
                                              "数量不可超过（" +
                                                _vm._s(
                                                  _vm.prizeData.length
                                                    ? _vm.prizeData[0]
                                                        .availableNumbers
                                                    : 0
                                                ) +
                                                "）个"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ]
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "中奖概率", prop: "winnerRate" } },
            [
              _c("el-input-number", {
                attrs: { precision: 2, controls: false, min: 0 },
                model: {
                  value: _vm.form.winnerRate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "winnerRate", $$v)
                  },
                  expression: "form.winnerRate",
                },
              }),
              _vm._v(" %\n    "),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "sort" } },
            [
              _c("el-input-number", {
                attrs: { controls: false, min: 0 },
                model: {
                  value: _vm.form.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "sort", $$v)
                  },
                  expression: "form.sort",
                },
              }),
              _c("span", { staticClass: "margin-left-10 font-12 color-" }, [
                _vm._v("数字越大，奖品位置越靠前"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.submit },
            },
            [_vm._v("保 存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }